define([
    'jquery',
    './vendor/bootstrap/modal'
], function($, modal) {
    'use strict';

    var init = function () {
         console.log(modal);

         setTimeout(function() {
             $('#inquiryModal').modal();
         }, 1000);

    };

    return {
        init: init
    };
});